<template>
  <div class="toast animate__animated animate__fadeIn">
    {{ title }}
  </div>
</template>

<script>
export default {
  name: 'Toast',
  props: {
    title: {
      type: String,
      required: true
    },
    delay: {
      type: Number,
      default: 1000
    }
  },
  mounted () {
    window.setTimeout(() => {
      document.body.removeChild(this.$parent.$el)
    }, this.delay)
  }
}
</script>

<style lang="less" scoped>
.toast{
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(50%, 50%,0);
  background-color: rgba(0,0,0,.6);
  font-size: 14px;
  padding: 8px 25px;
  color: white;
  border-radius: 14px;
}
</style>
